module.exports = __webpack_public_path__ + "static/media/lock.43a6c1ac.svg";